import React from 'react'
import ChronoSelect from '@/layouts/core/components/ChronoSelect'
import { CartItem } from '@/modules/cart/types/cart'

type CartItemOptionsProps = {
  fullWidth?: boolean,
  onUpdate: (number) => void
} & CartItem

const CartItemOptions = ({ product, option, fullWidth, onUpdate }: CartItemOptionsProps) => {
  return (
    <ChronoSelect
      data-cy={'cart_item_options'}
      name={'size'}
      label={'Size'}
      fullWidth={fullWidth}
      defaultValue={option?.id}
      sx={{
        marginRight: 2
      }}
      options={product.options.map(opt => ({
        name: opt.name,
        value: opt.id
      }))}
      onUpdate={(opt) => {
        onUpdate(parseInt(opt))
      }}
    />
  )
}

export default CartItemOptions